export default function AdGenerater (props) {
  const areaCheck = props.id;
  const bannerWidth = props.w ? props.w + 'px' : '970px';
  const bannerHeight = props.h ? props.h + 'px' : '90px';


  let srcUrl;

  if (areaCheck === 'top') {
    srcUrl = '/html/pc/top.htm';
  } else if (areaCheck === 'middle') {
    srcUrl = '/html/pc/middle.htm';
  } else if (areaCheck === 'live') {
    srcUrl = '/html/pc/live.htm';
  } else if (areaCheck === '24live_web_bottom_970_90') {
    srcUrl = '/html/pc/24live_web_bottom_970_90.htm';
  } else if (areaCheck === '24live_web_middle_970_90') {
    srcUrl = '/html/pc/24live_web_middle_970_90.htm';
  } else if (areaCheck === '24live_web_top_930_180') {
    srcUrl = '/html/pc/24live_web_top_930_180.htm';
  } else {
    srcUrl = '/html/pc/bottom.htm';
  }

  if (areaCheck === 'live_listcontents_topAD') {
    return (
      <div className='live_listcontents_topAD'>
        <iframe title='배너광고' display='block' src='/html/pc/24live_web_top_930_180.htm' width={bannerWidth} height={bannerHeight} scrolling='no' frameBorder='0' align='middle' marginWidth='0' marginHeight='0' />
      </div>
    );
  }

  // * 2023 항저우아시안게임
  if (areaCheck === 'live_top_ag_2023') {
    return (
      <div className='bigEventBanner_w'>
        <div className='bigEventBannerTop_w'>
          <iframe title='배너광고' className="bigEventBanner_img" display='block' src='/html/pc/live_top_ag_2023.htm' width='970px' height='90px' scrolling='no' frameBorder='0' marginWidth='0' marginHeight='0' align='middle' />
        </div>
      </div>
    );
  }

  // * 2023 항저우아시안게임
  if (areaCheck === 'live_left_ag_2023') {
    return (
      <div className='bigEventBanner_w'>
        <div className='bigEventBannerLeft_w'>
          <iframe title='배너광고' className="bigEventBanner_img" display='block' src='/html/pc/live_left_ag_2023.htm' width='120px' height='600px' scrolling='no' frameBorder='0' marginWidth='0' marginHeight='0' align='middle' />
        </div>
      </div>
    );
  }
  if (areaCheck === 'live_right_ag_2023') {
    return (
      <div className='bigEventBannerRight_w'>
        <iframe title='배너광고' className="bigEventBanner_img" display='block' src='/html/pc/live_right_ag_2023.htm' width='120px' height='600px' scrolling='no' frameBorder='0' marginWidth='0' marginHeight='0' align='middle' />
      </div>
    );
  }

  return (
    <div className={areaCheck.indexOf('live') > -1 ? 'contents_area_ad' : 'main_contents_ad'} id={(areaCheck === 'live') ? 'contents_area_ad' : 'main_contents_ad'}>
      <div className='ad_banner_w' style={{ width: bannerWidth, height: bannerHeight }}>
        <iframe title='배너광고' display='block' src={srcUrl} width={bannerWidth} height={bannerHeight} scrolling='no' frameBorder='0' align='middle' marginWidth='0' marginHeight='0' />
      </div>
    </div>
  );
}
